import React, { useState } from "react"
import TableComponent from "../../components/molecules/table"
import { HiearchicalTable, HiearchicalTableColumn } from "../../components/molecules/HiearchicalTable";
import { BOMItem } from "../machines/assetHistory/assetHistory";



  const columnNames : HiearchicalTableColumn<BOMItem>[] = [
    {
      displayName: "Part number",
      id: "partNumber",
    },
    {
      displayName: "Name",
      id: "name",
    },
    {
      displayName: "Quantity",
      id: "quantity",
      render: (r) => `${r.quantity} ${r.unit}`
    },
  ] 


export const BOMTable = ({ parts }: { parts: BOMItem }) => {
  return (
    <HiearchicalTable
      rows={parts}
      columnNames={columnNames}
      />
  )

}